const heapId = process.env.REACT_APP_HEAP_ID ?? '';

declare global {
  interface Window {
    heap: {
      appid: string;
      userId: string;
      identity: string | null;
      config: Record<string, unknown>;
      identify: (id: string) => void;
      addUserProperties: (properties: Record<string, unknown>) => void;
      track: (eventName: string, eventData?: Record<string, unknown>) => void;
      push: (args: unknown[]) => void;
      [key: string]: unknown;
    };
  }
}

export const heapInitialize = (): void => {
  if (heapId === '') {
    // eslint-disable-next-line no-console
    console.warn('Could not enable analytics -- no analytics id found.');
    return;
  }

  window.heap = window.heap || ([] as unknown as Window['heap']);

  const heap = window.heap;
  heap.appid = heapId;
  heap.config = {};

  const heapScriptElement = document.createElement('script');
  heapScriptElement.type = 'text/javascript';
  heapScriptElement.async = true;
  heapScriptElement.src = `https://cdn.heapanalytics.com/js/heap-${heapId}.js`;

  document.head.appendChild(heapScriptElement);

  const heapProperties = [
    'addEventProperties',
    'addUserProperties',
    'clearEventProperties',
    'identify',
    'resetIdentity',
    'removeEventProperty',
    'setEventProperties',
    'track',
    'unsetEventProperty',
  ];

  heapProperties.forEach(propertyName => {
    heap[propertyName] = function (...args: unknown[]) {
      heap.push([propertyName, ...args]);
    };
  });
};

export const getHeap = (): Window['heap'] | undefined => {
  if (!isHeapActive()) {
    return undefined;
  }
  return window.heap;
};

export const isHeapActive = (): boolean => {
  return heapId !== '';
};
